import { Component, NgModule, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { FilmSession } from 'src/app/models/film-session';
import { LiveSessionStatusService } from 'src/app/services/live-session-status.service';
import { MaterialModule } from '../../shared_modules/material/material.module';

/** Tells invited team members a live film session is running and lets them join it. */
@Component({
  selector: 'app-live-session-banner',
  templateUrl: './live-session-banner.component.html',
  styleUrls: ['./live-session-banner.component.css']
})
export class LiveSessionBannerComponent implements OnInit, OnDestroy {

  session: FilmSession = null;
  dismissedId: string = null;
  onSessionPage = false;
  private subscriptions = new Subscription();

  constructor(
    private router: Router,
    private liveSessionStatus: LiveSessionStatusService
  ) { }

  get visible(): boolean {
    return !!this.session && !this.onSessionPage && this.dismissedId !== this.session._id;
  }

  ngOnInit(): void {
    this.onSessionPage = this.isSessionUrl(this.router.url);
    this.subscriptions.add(this.router.events.pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe(event => this.onSessionPage = this.isSessionUrl(event.urlAfterRedirects)));
    this.subscriptions.add(this.liveSessionStatus.live$.subscribe(session => this.session = session));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  private isSessionUrl(url: string): boolean {
    return (url || '').startsWith('/live-session');
  }

  join(): void {
    if (this.session) this.router.navigate(['/live-session', this.session._id]);
  }

  dismiss(): void {
    this.dismissedId = this.session?._id;
  }
}

@NgModule({
  declarations: [LiveSessionBannerComponent],
  imports: [MaterialModule],
  exports: [LiveSessionBannerComponent],
})
export class LiveSessionBannerModule {}
